import { render } from "./VideoRecommendations.vue?vue&type=template&id=03dbdf2e&scoped=true"
import script from "./VideoRecommendations.vue?vue&type=script&lang=js"
export * from "./VideoRecommendations.vue?vue&type=script&lang=js"

import "./VideoRecommendations.vue?vue&type=style&index=0&id=03dbdf2e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dbdf2e"]])

export default __exports__